import { render, staticRenderFns } from "./CollectionPromoTile.vue?vue&type=template&id=73494197&scoped=true&lang=pug&"
import script from "./CollectionPromoTile.vue?vue&type=script&lang=js&"
export * from "./CollectionPromoTile.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPromoTile.vue?vue&type=style&index=0&id=73494197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73494197",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73494197')) {
      api.createRecord('73494197', component.options)
    } else {
      api.reload('73494197', component.options)
    }
    module.hot.accept("./CollectionPromoTile.vue?vue&type=template&id=73494197&scoped=true&lang=pug&", function () {
      api.rerender('73494197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionPromoTile.vue"
export default component.exports